<template>
  <div
    class="homecontainer"
    :class="{ bg2: showRank || showRule }"
    v-wechat-title="setting.gameName"
  >
    <div
      v-show="!showRank && !showRule && hasGetSetting"
      :style="{ background: `url(${bgImg}) 0 0/100% 100% no-repeat` }"
      class="index"
    >
      <!-- <div class="banner animated bounceInDown slow">
        <img
          :src="getImage(setting.logo)"
          alt
          style="width: 100%; height: 100%"
          v-if="setting.logo"
        />
      </div> -->
      <div class="button">
        <div
          class="rank animated bounceInUp slow"
          @click="viewRank"
          v-show="showButton"
        >
          <img
            :src="$store.state.themeImgs.length ? $store.state.themeImgs[7] : require('../../assets/images/ranklist.png')"
            alt
            style="width: 100%; height: 100%"
          />
        </div>
        <div
          class="start animated bounceInUp slow"
          :class="{ center: !showButton }"
          @click="startGame"
        >
          <img
            :src="$store.state.themeImgs.length ? $store.state.themeImgs[8] : require('../../assets/images/start.png')"
            alt
            style="width: 100%; height: 100%"
          />
        </div>
      </div>
      <div class="rule animated bounceInUp slower" @click="openRule">
        <img
          src="../../assets/images/rule.png"
          alt
          style="width: 100%; height: 100%"
        />
      </div>
      <div class="quit" @click="quit" v-show="isLogin">
        <img
          src="../../assets/images/quit.png"
          alt
          style="width: 100%; height: 100%"
        />
      </div>
    </div>
    <!-- 排行榜 -->
    <div
      v-show="showRank"
      class="rule-wrapper"
      :style="{ background: `url(${bgImg2}) 0 0/100% 100% no-repeat` }"
    >
      <logo :museumCode="museumCode"></logo>

      <div class="rank-title animated bounceInDown slow">
        <img
          :src="$store.state.themeImgs.length ? $store.state.themeImgs[5] : require('../../assets/images/rank.png')"
          alt
          style="width: 100%; height: 100%"
        />
      </div>
      <div class="rank-content animated bounceInUp slower">
        <el-table
          :data="rankList"
          border
          v-loadmore="loadMore"
          style="width: 100%"
          :max-height="tableHeight"
          ref="rankList"
        >
          <template slot="empty">
            {{noDataText}}
          </template>
          <el-table-column
            prop="id"
            label="名次"
            type="index"
            :index="indexMethod"
            align="center"
            :width="tableColumnWidth"
          ></el-table-column>
          <el-table-column
            prop="mobilePhone"
            label="闯关者"
            align="center"
            min-width="100"
          ></el-table-column>
          <el-table-column
            prop="gameNumber"
            label="关卡"
            align="center"
            min-width="80"
          ></el-table-column>
          <el-table-column
            prop="timeUsed"
            label="时间"
            align="center"
            min-width="80"
          ></el-table-column>
        </el-table>
      </div>
      <div class="home animated bounceInUp slower delay-1s" @click="returnHome">
        <img
          :src="$store.state.themeImgs.length ? $store.state.themeImgs[0] : require('../../assets/images/home.png')"
          alt
          style="width: 100%; height: 100%"
        />
      </div>
    </div>
    <!-- 游戏规则 -->
    <div
      v-show="showRule"
      class="rule-wrapper"
      :style="{ background: `url(${bgImg2}) 0 0/100% 100% no-repeat` }"
    >
      <logo :museumCode="museumCode"></logo>

      <div class="rule-title animated bounceInDown slow">
        <img
          src="../../assets/images/rule.png"
          alt
          style="width: 100%; height: 100%"
        />
      </div>
      <div class="rule-content animated bounceInUp slower">
        <p v-html="setting.gameRule"></p>
      </div>
      <div class="home animated bounceInUp slower delay-1s" @click="returnHome">
        <img
          :src="$store.state.themeImgs.length ? $store.state.themeImgs[0] : require('../../assets/images/home.png')"
          alt
          style="width: 100%; height: 100%"
        />
      </div>
    </div>
    <popup v-show="dialog" :status="status" ref="popup"></popup>
  </div>
</template>

<script>
import { WOW } from "wowjs";
// import elTableInfiniteScroll from "el-table-infinite-scroll";
import popup from "@/components/popup";
import logo from "@/components/logo";
// import wechatJS from '@/utils/wechat'  // 引入wechat.js
import wx from "weixin-js-sdk"; // 引入wxJS
import backgroundImg from "@/assets/images/bg.jpg";
import backgroundImg2 from "@/assets/images/bg1.jpg";

export default {
  name: "home",
  // directives: {
  //   "el-table-infinite-scroll": elTableInfiniteScroll
  // },
  directives: {
    // "el-table-infinite-scroll": elTableInfiniteScroll
    loadmore: {
      bind(el, binding) {
        const selectWrap = el.querySelector(".el-table__body-wrapper");
        var canRun = true;
        selectWrap.addEventListener("scroll", function () {
          // console.log(this.scrollHeight,this.scrollTop,this.clientHeight)
          if (!canRun) {
            // 判断是否已空闲，如果在执行中，则直接return
            return;
          }
          canRun = false;
          var that = this;
          setTimeout(function () {
            console.log("函数节流");
            console.log(that.scrollHeight, that.scrollTop, that.clientHeight);
            if (that.scrollHeight - that.scrollTop <= that.clientHeight + 1) {
              // alert('请求新数据')
              console.log(selectWrap);
              selectWrap.scrollTop = that.scrollTop - 1;
              binding.value();
            }
            canRun = true;
          }, 1000);
        });
      },
    },
  },
  components: {
    popup,
    logo,
  },
  data() {
    return {
      setting: "", // 游戏设置
      showRank: false, // 是否显示排行榜
      showRule: false, //是否显示游戏规则
      rankList: [], // 排行榜
      gameCode: "", //游戏编码
      dialog: false, // 是否弹窗
      status: "",
      startTime: "", //游戏开始时间
      endTime: "", //游戏结束时间
      page: 1, //页码
      limit: 20, //每页数量
      datalist: [], //新增数据
      showButton: true, //隐藏展示按钮'
      museumCode: "", //场馆code
      imgPath: "", //分享图片路径
      slotName: "",
      slotDesc: "",
      config: {},
      tableHeight: "", //表格高度
      tableColumnWidth: "", //表头宽度
      bgImg2: backgroundImg2,//排行榜及游戏规则的背景图
      crtTime: '',
      noDataText: '加载中',
      canHandelButton: true,
      hasGetSetting: false,
    };
  },

  created() {},
  mounted() {
    if (this.getQueryStringRegExp("gameCode")) {
      this.$store.state.gameCode = this.getQueryStringRegExp("gameCode").split('#')[0];
      if (
        this.getQueryStringRegExp("gameCode") === "zhstsg#/" ||
        this.getQueryStringRegExp("gameCode") === "zhstsg"
      ) {
        this.showButton = false;
      }
    } else {
      this.$store.state.gameCode = window.SITE_CONFIG.gameCode;
    }
    this.$store.state.name = this.$cookie.get('name') || '';
    this.$store.state.unit = this.$cookie.get('unit') || '';
    console.log(this.getQueryStringRegExp("platform"));
    if (this.getQueryStringRegExp("platform").indexOf("gede") === 0) {
      console.log("一体机");
      this.$store.state.platform = "gede";
    } else {
      console.log("手机");
      this.$store.state.platform = "mobilePhone";
     console.log(
        this.$cookie.get(`${this.$store.state.gameCode}_phoneNumber`)
      );
      this.$store.state.phoneNumber = this.$cookie.get(
        `${this.$store.state.gameCode}_phoneNumber`
      );
      this.$store.state.phoneNumber
        ? (this.$store.state.isLogin = true)
        : (this.$store.state.isLogin = false);
    }
    console.log(this.$store.state.phoneNumber);
    console.log(this.$route.params.view);
    if (this.$route.params.view === true) {
      this.showRank = true;
    }
    var wow = new WOW({
      live: false,
    });
    wow.init();
    this.getSetting();
    this.$nextTick(() => {
      this.tableHeight = window.innerHeight / 2;
      this.tableColumnWidth = window.innerWidth / 6;
    });
  },
  methods: {
    // 获取地址栏信息
    getQueryStringRegExp(name) {
      var reg = new RegExp("(^|\\?|&)" + name + "=([^&]*)(\\s|&|$)", "i");
      if (reg.test(location.href))
        return unescape(RegExp.$2.replace(/\+/g, " "));
      return "";
    },
        // 获取主题图片
    getThemeImg() {
      this.$http({
        url: this.$http.adornUrl(
          `/api/portal/front/img/slot?museumCode=${this.museumCode}&slotCode=themeImg_${this.$store.state.gameCode}`
        ),
        method: "get",
      }).then((res) => {
        if (!res.data.data.rows.length) return
        this.$store.state.themeImgs = res.data.data.rows[0].imgDetailList.map((item) => {
          return this.getImage(item.imgPath)
        })
        console.log(this.$store.state.themeImgs)
      });
    },

    startGame() {
      //判断是否在游戏时间内
      Date.prototype.format = function (fmt) {
        var o = {
          "M+": this.getMonth() + 1, //月份
          "d+": this.getDate(), //日
          "h+": this.getHours(), //小时
          "m+": this.getMinutes(), //分
          "s+": this.getSeconds(), //秒
          "q+": Math.floor((this.getMonth() + 3) / 3), //季度
          S: this.getMilliseconds(), //毫秒
        };
        if (/(y+)/.test(fmt)) {
          fmt = fmt.replace(
            RegExp.$1,
            (this.getFullYear() + "").substr(4 - RegExp.$1.length)
          );
        }
        for (var k in o) {
          if (new RegExp("(" + k + ")").test(fmt)) {
            fmt = fmt.replace(
              RegExp.$1,
              RegExp.$1.length == 1
                ? o[k]
                : ("00" + o[k]).substr(("" + o[k]).length)
            );
          }
        }
        return fmt;
      };
      var myDate = new Date().format("yyyy-MM-dd hh:mm:ss");
      console.log(myDate);
      if (myDate < this.startTime) {
        console.log("活动未开始");
        this.status = "nostart";
        this.dialog = true;
      } else if (myDate > this.endTime) {
        console.log("活动已结束");
        this.status = "end";
        this.dialog = true;
      } else {
        if (this.$store.state.isLogin) {
          if (!this.canHandelButton) return
          this.canHandelButton = false
          if (this.$store.state.submitLimit && this.$store.state.totalCount && this.$store.state.submitLimit - this.$store.state.totalCount <= 0) {
            this.dialog = true;
            this.status = "noLeftCount";
            return
          }

          this.$http({
            url: this.$http.adornUrl(
            `/api/game/front/game-record/phone?mobilePhone=${this.$store.state.phoneNumber}&gameId=${this.$store.state.id}&name=${this.$store.state.name}&unit=${this.$store.state.unit}`
            ),
            method: "post",
          }).then((res) => {
            console.log(res.data);
            this.canHandelButton = true
            if (!res.data.rel && res.data.data == '该账号状态存在异常') {
              this.dialog = true;
              this.status = "leftCount";
              this.$refs.popup.leftCount = '该账号状态存在异常'
            }
            // alert(res.data.message)
            this.$store.state.submitLimit
              ? (this.leftCount = this.$store.state.submitLimit - res.data.data)
              : null;
            var _this = this;
            if (res.data.status === 200 && res.data.rel) {
              _this.$router.replace({
                name: "answer",
              });
            } else {
              this.dialog = true;
              this.status = "noLeftCount";
            }
          });
        } else {
          this.status = "login";
          this.dialog = true;
        }
        // this.$router.push({
        //   name: "answer",
        //   params: { id: this.setting.id, titleImage: this.setting.titleImage },
        // });
      }
    },
    // 有token
    getPhoneByToken(token) {
      this.$store.state.isLogin = true
      this.status = "leftCount";
      this.$cookie.set('token', token)
      // this.dialog = true;
      // document.cookie = `${this.$store.state.gameCode}_phoneNumber=${this.numberValidateForm.mobilePhone};max-age=3600`;
      this.getPhone(token)
      this.$refs.popup.getLeftCount()
    },

    getPhone(token) {
      this.$http({
        url: this.$http.adornUrl(
          `/api/auth/jwt/username`
        ),
        method: "get",
        headers: {
        'Authorization': token
        }
      }).then((res) => {
        // console.log(this.$store.state.gameCode)
        this.$cookie.set(`${this.$store.state.gameCode}_phoneNumber`, res.data.data)
        // document.cookie = `${this.$store.state.gameCode}_phoneNumber=${res.data.data};max-age=3600`;
        this.$store.state.phoneNumber = res.data.data
      })
    },

    closeDialog() {
      this.dialog = false;
    },
    openRule() {
      this.showRule = true;
    },
    returnHome() {
      this.showRule = false;
      this.showRank = false;
    },
    // 返回并刷新首页
    loadHome() {
      location.reload();
    },
    // 查看排名
    viewRank() {
      this.showRank = true;
      document.body.style.background =
        'url("../../assets/images/bg.jpg") 0 0/100% 100% no-repeat !important';
    },
    getImage(image) {
      return window.SITE_CONFIG.imageRootUrl + image;
    },
    // :获取游戏设置
    getSetting() {
      this.$http({
        url: this.$http.adornUrl(
          "/api/game/front/setting/code/" + this.$store.state.gameCode
        ),
        method: "get",
      }).then((res) => {
        this.hasGetSetting = true
        // console.log(res.data.data);
        this.setting = res.data.data;
        this.$store.state.id = res.data.data.id;
        this.startTime = res.data.data.startTime;
        this.endTime = res.data.data.endTime;
        this.museumCode = res.data.data.museumCode;
        this.$store.state.museumCode = res.data.data.museumCode;
        this.$store.state.bgImg = res.data.data.bgImg;
        this.$store.state.correctImg = res.data.data.resultImg;
        this.$store.state.errorImg = res.data.data.errorImg;
        this.$store.state.submitLimit = res.data.data.submitLimit;
        this.$store.state.prizeHint = res.data.data.prizeHint;
        this.$store.state.showName = res.data.data.showName;
        this.$store.state.showUnit = res.data.data.showUnit;
        this.crtTime = res.data.data.crtTime
        // console.log(this.$store.state.id);
        sessionStorage.setItem("authTime", this.setting.timeout);
        sessionStorage.setItem("backTime", this.setting.backTime);
        this.getWeChatShareSetting();
        this.getBackground();
        this.getThemeImg()
        console.log(this.$route.query.token)
        if (this.$route.query.token) {
          this.getPhoneByToken(this.$route.query.token)
        }

      });
    },
    // 获取背景图片
    getBackground() {
      this.$http({
        url: this.$http.adornUrl(
          `/api/portal/front/img/slot?museumCode=${this.museumCode}&slotCode=background&adCode=${this.$store.state.gameCode}`
        ),
        method: "get",
      }).then((res) => {
        this.$store.state.bgImg2 =
          res.data.data.rows[0].imgDetailList[0].imgPath;
        this.bgImg2 = this.getImage(
          res.data.data.rows[0].imgDetailList[0].imgPath
        );
      });
    },

    // 获取微信分享配置
    getWeChatShareSetting() {
      let timeNow = 1618243200000 //2021.4.9
      let url = Date.parse(this.crtTime) > timeNow ? `/api/portal/front/img/slot?museumCode=${this.museumCode}&adCode=share&slotCode=${this.$store.state.gameCode}` : `/api/portal/front/slot?museumCode=${this.museumCode}&slotName=wxShareGameSlot`
      this.$http({
        url: this.$http.adornUrl(url),
        method: "get",
      }).then((res) => {
        var result = res.data.data.rows[0];
        let resultDetail = Date.parse(this.crtTime) > timeNow ? result.imgDetailList[0] : result.adDetails[0]
        let desc = resultDetail.adDesc.replace('<p>', '')
        this.slotName = resultDetail.adName;
        this.slotDesc = desc.replace('</p>', '');
        this.imgPath = Date.parse(this.crtTime) > timeNow ?resultDetail.imgPath : result.imgPath;
        this.wechatShare();
      })
    },
    wechatShare() {
      // this.$http({
      //   url: "http://map.museum.chaoxing.com/beacon/config?url=" + window.location.href,
      //   method: "get"
      // }).then(res => {
      //   console.log(res)
      //   this.config = res
      // }).catch(err => {
      //   console.log(err)
      // });
      var promise = new Promise((resove, reject) => {
        this.$http({
          url:
            "http://map.museum.chaoxing.com/beacon/config?url=" +
            window.location.href,
          method: "get",
        })
          .then((res) => {
            // console.log(res)
            resove(res);
            // this.config = res
          })
          .catch((err) => {
            console.log(err);
            reject;
          });
      });
      promise.then((data) => {
        console.log(data.data);
        wx.config({
          debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
          appId: data.data.appId, // 必填，公众号的唯一标识
          timestamp: data.data.timestamp, // 必填，生成签名的时间戳
          nonceStr: data.data.nonceStr, // 必填，生成签名的随机串
          signature: data.data.signature, // 必填，签名，见附录1
          jsApiList: [
            "startSearchBeacons",
            "onSearchBeacons",
            "updateAppMessageShareData",
            "updateTimelineShareData",
            "onMenuShareAppMessage",
            "onMenuShareTimeline",
          ],
          // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
        });
        var shareConfig = {
          share: {
            imgUrl: window.SITE_CONFIG.imageRootUrl + this.imgPath, // 分享图标
            desc: this.slotDesc, // 分享描述
            title: this.slotName, // 分享标题
            link: window.location.href, //分享出去后的链接，这里可以将链接设置成另外一个页面，必须在同一域名下面
            success: function () {
              //分享成功之后的回调
              console.log("分享成功");
            },
            cancel: function () {
              //用户取消分享后执行
            },
          },
        };
        console.log(shareConfig);
        wx.ready(function () {
          console.log("签名验证成功");
          wx.onMenuShareAppMessage(shareConfig.share);
          wx.onMenuShareTimeline(shareConfig.share);

          wx.updateAppMessageShareData(shareConfig.share);
          wx.updateTimelineShareData(shareConfig.share);
          console.log(shareConfig.share);

          wx.error(function (res) {
            // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
            console.log(JSON.stringify(res));
          });
          wx.checkJsApi({
            jsApiList: ["updateAppMessageShareData", "onMenuShareAppMessage"], // 需要检测的JS接口列表，所有JS接口列表见附录2,
            success: function (res) {
              // 以键值对的形式返回，可用的api值true，不可用为false
              // 如：{"checkResult":{"chooseImage":true},"errMsg":"checkJsApi:ok"}
              console.log(JSON.stringify(res));
            },
          });
          // ================
          // 分享给朋友圈
          wx.updateTimelineShareData({
            title: this.slotName, // 分享标题
            link: window.location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
            imgUrl:
              "http://file.museum.chaoxing.com/weixin/images/" + this.slotName, // 分享图标
            success: function () {
              // 设置成功
            },
          });
        });
      });
    },
    // :退出游戏
    windowclose() {
      var browserName = navigator.appName;
      if (browserName === "Netscape") {
        window.open("", "_self", "");
        window.close();
      } else {
        if (browserName === "Microsoft Internet Explorer") {
          window.opener = "whocares";
          window.opener = null;
          window.open("", "_top");
          window.close();
        }
      }
    },
    // 退出登录
    quit() {
      this.$cookie.set('name', '')
      this.$cookie.set('token', '')
      this.$cookie.set('unit', '')
      this.$store.state.isLogin = false;
      document.cookie = `${this.$store.state.gameCode}_phoneNumber='';max-age=-1`;
    },
    // 获取排行榜
    getRankList() {
      this.page = 1;
      this.$http({
        url: this.$http.adornUrl(
          "/api/game/front/record/" +
            this.$store.state.id +
            "?page=" +
            this.page +
            "&limit=" +
            this.limit
        ),
        method: "get",
      }).then((res) => {
        this.rankList = [];
        res.data.data.forEach((element) => {
          // console.log(element)
          var rankItem = {
            gameId: element.gameId,
            gameNumber: "第" + element.gameNumber + "题",
            id: element.id,
            mobilePhone: this.userpattern(element.mobilePhone),
            timeUsed: element.timeUsed / 1000 + "s",
          };
          this.rankList.push(rankItem);
          if (!this.rankList.length) this.noDataText = '暂无数据'
        });
      });
    },
    // 显示对应名次
    indexMethod(index) {
      return "第" + (Number(index) + 1) + "名";
    },
    // 手机号隐私化处理
    userpattern(val) {
      let strVal = val.toString();
      return `${strVal.substring(0, 3)}****${strVal.substring(
        strVal.length - 4
      )}`;
    },
    //分页获取排行榜数据
    loadMore() {
      // console.log(this.datalist.length)
      this.page++;
      console.log("新页面", this.page);
      // 联网请求
      this.$http(
        this.$http.adornUrl("/api/game/front/record/" + this.$store.state.id),
        {
          params: {
            page: this.page, // 页码
            limit: this.limit, // 每页长度
          },
        }
      ).then((response) => {
        // 请求的列表数据
        // 处理数据
        // console.log(response.data.data);
        response.data.data.forEach((element) => {
          // console.log(element);
          var rankItem = {
            gameId: element.gameId,
            gameNumber: "第" + element.gameNumber + "题",
            id: element.id,
            mobilePhone: this.userpattern(element.mobilePhone),
            timeUsed: element.timeUsed / 1000 + "s",
          };
          // console.log(rankItem);
          // console.log(this.datalist);
          if (rankItem) {
            this.datalist.push(rankItem);
          }
          // console.log(this.datalist);
        });
        // 如果是第一页需手动置空列表
        if (this.page === 1) this.rankList = [];
        // 把请求到的数据添加到列表
        if (this.datalist) {
          this.rankList = this.rankList.concat(this.datalist);
        }
        this.datalist = [];
      });
    },
  },
  watch: {
    showRank() {
      if (this.showRank) {
        this.getRankList();
        this.$nextTick(() => {
          const selectWrap = document.querySelector(".el-table__body-wrapper");
          selectWrap.scrollTop = 0;
          console.log("showRank -> selectWrap.scrollTop", selectWrap.scrollTop);
        });
      }
    },
    config() {
      console.log(this.config);
    },
  },
  computed: {
    bgImg: function () {
      return this.setting.bgImg || this.$store.state.bgImg
        ? this.getImage(this.setting.bgImg)
        : backgroundImg;
    },
    isLogin() {
      return this.$store.state.isLogin;
    },
  },
};
</script>

<style lang="scss">
$small: 375px;
$medium: 1079px;
$big: 1921px;
.bg2 {
  // background: url("../../assets/images/bg.jpg") 0 0/100% 100% no-repeat !important;
}

.homecontainer {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  @media screen and (max-width: $small) {
    // background: url("") 0 0/100% 100% no-repeat;
    // background-color: #163f9b;
  }
  //一体机
  @media screen and (min-width: $small) and (max-width: $medium) {
    // background: url("../../assets/images/bg.jpg") 0 0/100% 100% no-repeat;
    // background-color: #163f9b;
  }
  //PC端
  @media screen and (min-width: $medium) and (max-width: $big) {
    width: 100%;
    height: 100%;
    // background: url("../../assets/images/bg.jpg") 0 0/100% 100% no-repeat;
    // background-color: #163f9b;
  }
  // background: url("../../assets/images/logo.png") 0 0/100% 100% no-repeat !important;

  > div {
    margin: 0 auto;
    img {
      display: block;
    }
  }
  .index {
    box-sizing: border-box;
    width: 100%;
    height: 100%;
    padding-top: 20%;
    @media screen and (min-height: 0) and (max-height: 500px) {
      // max-height: 56%;
      // padding-top: 15%;
    }
  }
  .banner {
    // width: 100%;
    width: 7.454rem;
    max-height: 10.324rem;
    margin: 0 auto;
    // background: url("../../assets/images/logo.png") 0 0/100% 100% no-repeat !important;
    // @media screen and (min-height: 0) and (max-height: 500px) {
    //   // max-height: 56%;
    //   margin: 0 auto;
    //   width: 4.8448rem;
    //   max-height: 7.096rem;
    // }
    // @media screen and (min-height: 500px) and (max-height: 600px) {
    //   // max-height: 56%;
    //   margin: 0 auto;
    //   width: 5.3254rem;
    //   max-height: 7.858rem;
    // }
  }
  .button {
    width: 7.111rem;
    height: 0.824rem;
    // margin: 0 auto;
    position: fixed;
    left: 50%;
    margin-left: -3.5555rem;
    bottom: 10%;
    > div {
      display: inline-block;
      width: 2.778rem;
      height: 0.833rem;
    }
    .rank {
      float: left;
    }
    .start {
      float: right;
    }
    .center {
      float: none;
    }
  }
  .rule {
    width: 1.519rem;
    height: 0.361rem;
    // margin: 0 auto;
    position: fixed;
    bottom: 5%;
    left: 50%;
    margin-left: -0.7595rem;
  }
  .close {
    width: 0.556rem;
    height: 0.444rem;
    margin: 0.5rem auto 0 auto;
    position: absolute;
    bottom: 2.454rem;
    left: 50%;
    margin-left: -0.278rem;
  }
  .rule-wrapper {
    box-sizing: border-box;
    height: 100%;
    width: 100%;
    padding-top: 10%;
  }
  .rule-title {
    width: 4.5rem;
    height: 1rem;
    margin: 0 auto 1rem;
    // // pc端
    // @media screen and (min-width: 1081px) and (max-width: $big) {
    //   margin: 2.241rem auto 0.981rem auto;
    // }
    // // 一体机
    // @media screen and (min-width: $medium) and (max-width: 1081px) {
    //   margin: 0.981rem auto;
    // }
  }
  .rule-content {
    width: 8.074rem;
    height: 60%;
    overflow-y: auto;
    overflow-x: hidden;
    margin: 0 auto 1rem auto;
    -ms-overflow-style: none;
    overflow: -moz-scrollbars-none;
    &::-webkit-scrollbar {
      width: 0 !important;
    }
    p {
      font-size: 0.45rem;
      color: #fff;
    }
  }

  .rank-title {
    width: 3.444rem;
    height: 1.019rem;
    margin: 0 auto;
  }
  .rank-content {
    width: 90%;
    height: 53%;
    overflow-y: hidden;
    border-radius: 0.046rem;
    border: solid 2px #fff;
    margin: 10% auto 0.87rem auto;
    @media screen and (min-width: $small) and (max-width: $medium) {
      // max-height: 56%;
    }
    .el-table {
      background: transparent;
      td {
        height: 0.565rem;
        border-bottom: none;
        border-right: solid 1px rgba($color: #fff, $alpha: 0.5);
      }
      th {
        border-bottom: solid 2px #fff;
        border-right: solid 1px rgba($color: #fff, $alpha: 0.5);
      }
      .el-table__header-wrapper {
        .cell {
          font-family: PingFangSC-Regular;
          font-size: 0.385rem;
          font-weight: normal;
          font-stretch: normal;
          line-height: 0.463rem;
          letter-spacing: 0rem;
          color: #fff;
          @media screen and (max-width: 374px) {
            font-size: 0.4rem;
          }
        }
      }
      .el-table__body-wrapper {
        .cell {
          div {
            font-family: PingFangSC-Regular;
            font-size: 0.3rem;
            font-weight: normal;
            font-stretch: normal;
            line-height: 0.35rem;
            letter-spacing: 0rem;
            color: #fff;
            @media screen and (max-width: 374px) {
              font-size: 0.35rem;
            }
          }
          font-family: PingFangSC-Regular;
          font-size: 0.3rem;
          font-weight: normal;
          font-stretch: normal;
          line-height: 0.463rem;
          letter-spacing: 0rem;
          color: #fff;
          padding-left: 5px;
          @media screen and (max-width: 374px) {
            font-size: 0.35rem;
          }
        }
        tbody {
          tr {
            &:nth-child(1) {
              td {
                &:nth-child(1) {
                  .cell {
                    div {
                      width: 90%;
                      height: 100%;
                      background-color: #eaca37;
                      border-radius: 0.148rem;
                      margin: 0 auto;
                      @media screen and (max-width: $medium) {
                        height: 0.4rem;
                        width: 1.4rem;
                        margin: 0 auto;
                        line-height: 0.4rem;
                      }
                    }
                  }
                }
              }
            }
            &:nth-child(2) {
              td {
                &:nth-child(1) {
                  .cell {
                    div {
                      width: 90%;
                      height: 100%;
                      background-color: #c3c1b8;
                      border-radius: 0.148rem;
                      margin: 0 auto;
                      @media screen and (max-width: $medium) {
                        height: 0.4rem;
                        width: 1.4rem;
                        margin: 0 auto;
                        line-height: 0.4rem;
                      }
                    }
                  }
                }
              }
            }
            &:nth-child(3) {
              td {
                &:nth-child(1) {
                  .cell {
                    div {
                      width: 90%;
                      height: 100%;
                      background-color: #c67d4c;
                      border-radius: 0.148rem;
                      margin: 0 auto;
                      @media screen and (max-width: $medium) {
                        height: 0.4rem;
                        width: 1.4rem;
                        margin: 0 auto;
                        line-height: 0.4rem;
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }

    .el-table th,
    .el-table tr {
      background-color: transparent;
    }
    .el-table__body tr:hover > td {
      background-color: transparent;
    }
    .el-table--border:after,
    .el-table--group:after {
      width: 0;
    }
  }
  .home {
    width: 2.778rem;
    height: 0.833rem;
    position: fixed;
    bottom: 10%;
    left: 50%;
    margin-left: -1.389rem;
  }
  .quit {
    position: fixed;
    top: 11%;
    right: 3%;
    height: 0.6rem;
    width: 1.2rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/common/home.vue